import React from 'react';
import styles from './Music.module.css';

// Import EP images
import ep1Image from '../../assets/images/mobdrama_ep.jpg';
import ep2Image from '../../assets/images/mobdrama_ep2.jpg';

// Import music platform logos
import appleMusicLogo from '../../assets/images/AppleMusic.png';
import spotifyLogo from '../../assets/images/spotifylogo.png';

const Music: React.FC = () => {
    return (
        <div className={styles.music}>
            <h1>Music</h1>
            <p>This is the music page where you can find information about our music.</p>
            
            <div className={styles.epContainer}>
                <div className={styles.ep}>
                    <h2>Mob Drama EP</h2>
                    <img src={ep1Image} alt="Mob Drama EP" className={styles.epImage} />
                    <div className={styles.platforms}>
                        <a href="https://music.apple.com/us/album/mob-drama-ep/1737552600" target="_blank" rel="noopener noreferrer" className={styles.waveEffect}>
                            <img src={appleMusicLogo} alt="Apple Music" className={styles.platformLogo} />
                        </a>
                        <a href="https://open.spotify.com/album/5V4LJZLkA1bjtFZOHs02sP?si=jupMWU6sQGGf9LX4c4kFjQ" target="_blank" rel="noopener noreferrer" className={styles.waveEffect}>
                            <img src={spotifyLogo} alt="Spotify" className={styles.platformLogo} />
                        </a>
                    </div>
                </div>

                <div className={styles.ep}>
                    <h2>Mob Drama EP II</h2>
                    <img src={ep2Image} alt="Mob Drama EP II" className={styles.epImage} />
                    <div className={styles.platforms}>
                        <a href="https://music.apple.com/us/album/mob-drama-ii-ep/1737552423" target="_blank" rel="noopener noreferrer" className={styles.waveEffect}>
                            <img src={appleMusicLogo} alt="Apple Music" className={styles.platformLogo} />
                        </a>
                        <a href="https://open.spotify.com/album/66ZuJBbNY04GqbW7kdcuw2?si=V42aiU58RMShv1M-msAoig" target="_blank" rel="noopener noreferrer" className={styles.waveEffect}>
                            <img src={spotifyLogo} alt="Spotify" className={styles.platformLogo} />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Music;
